<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useSettingsLogo } from '@/settings'
import { useSettingsStore } from '@/stores/settingsStore'

const settingsLogo = useSettingsLogo()
const settingsStore = useSettingsStore()
const { settings } = storeToRefs(settingsStore)

const logo = computed(() => settingsLogo.logo)
const currentYear = new Date().getFullYear()
const buildTime = document.querySelector('#app')?.getAttribute('data-time') || ''
</script>

<template>
  <footer class="footer">
    <div class="footer__brand">
      <img
        v-if="logo"
        class="footer__logo"
        :src="logo"
        alt="BETR"
      >
      <span v-if="settings?.orgName">{{ settings.orgName }}</span>
    </div>

    <div class="footer__meta">
      <span v-if="buildTime">Сборка: {{ buildTime }}</span>
      <span>© 2014–{{ currentYear }}</span>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 60px;
  padding: 10px 16px;
  color: var(--ui-text-muted);
  background: var(--ui-surface-soft);
  border: 1px solid var(--ui-border);
  border-radius: var(--ui-radius-md);
  font-size: 0.75rem;
}

.footer__brand,
.footer__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.footer__brand span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.footer__logo {
  flex: 0 0 auto;
  max-width: 72px;
  max-height: 32px;
  filter: grayscale(100%);
  opacity: 0.72;
}

.footer__meta {
  justify-content: flex-end;
  white-space: nowrap;
}

@media (max-width: 959px) {
  .footer {
    margin: 0 var(--ui-content-padding-mobile) var(--ui-content-padding-mobile);
  }
}

@media (max-width: 599px) {
  .footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }

  .footer__brand,
  .footer__meta {
    width: 100%;
  }

  .footer__meta {
    justify-content: space-between;
    white-space: normal;
  }
}
</style>
